import { Component,OnInit,OnDestroy,AfterViewInit,Input } from "@angular/core";
import { NgbModal,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { takeWhile } from "rxjs/operators";

import {
    DtgListType
} from "src/app/shared/vo";

@Component({
  templateUrl: "./geofence.conf.search.component.html"
  ,styleUrls: ["./geofence.conf.search.component.scss"]
})
export class GeofenceConfSearchComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    listItem:any[];
    DtgListType = DtgListType;

    constructor(
        private modalService: NgbModal
        ,public activeModal: NgbActiveModal
    ) {
        
    }

    ngOnInit() {
        
    }

    ngOnDestroy() {
        this.isContinue = false;
    }
    
    ngAfterViewInit() {}

    clickCancel(){
        this.activeModal.close({
            "result":"cancel"
        });
    }

    callbackSelectConf(confInfo:any){
        this.clickSelectConf(confInfo);
    }

    clickSelectConf(confInfo:any){
        this.activeModal.close({
            "result":"ok"
            ,"confInfo":confInfo
        });
    }
}
